import * as Yup from 'yup';

export const SCRIPT_MAX_LENGTH = 1500;

export const SpotlightSchema = Yup.object().shape({
  text: Yup.string()
    .max(
      SCRIPT_MAX_LENGTH,
      `Script cannot exceed ${SCRIPT_MAX_LENGTH} characters.`
    )
    .required('Script text is required.'),
});
